import { apiService } from '@/ApiClient/ApiService'
import { FilterWireSpec, serializeTableFilters } from '@/lib/tableFilters'

export interface DataTableFetchParams {
  pageIndex: number
  pageSize: number
  sorting?: any[]
  filters?: any[]
  [key: string]: any
}

export interface DataTableServiceOptions {
  endpoint: string
  defaultOrder?: 'ASC' | 'DESC'
  extraParams?: Record<string, any>
  paramPreprocessor?: (params: DataTableFetchParams) => Record<string, any>
  filterSpecs?: Record<string, FilterWireSpec>
}

export function createDataTableService<T>({
  endpoint,
  defaultOrder = 'ASC',
  extraParams = {},
  paramPreprocessor,
  filterSpecs,
}: DataTableServiceOptions) {
  return async ({
    pageIndex,
    pageSize,
    sorting = [],
    filters = [],
    ...rest
  }: DataTableFetchParams) => {
    // console.log('🚀 ~ createDataTableService:', endpoint, {
    // pageIndex,
    // pageSize,
    // sorting,
    // filters,
    // ...rest,
    // })
    try {
      const sort = sorting.length > 0 ? sorting[0] : null
      const orderBy = sort ? sort.id : undefined
      const order = sort ? (sort.desc ? 'DESC' : 'ASC') : defaultOrder

      const filtersString = serializeTableFilters(
        (filters ?? []).filter(f => f.value !== undefined && f.value !== ''),
        filterSpecs
      )

      let params: Record<string, any> = {
        order,
        orderBy,
        page: pageIndex || 1,
        take: pageSize,
        ...(filtersString ? { filters: filtersString } : {}),
        ...extraParams,
        ...rest,
      }

      if (paramPreprocessor) {
        params = paramPreprocessor(params as DataTableFetchParams)
      }

      const response = await apiService.fetchPaginated<T>(endpoint, { params })
      return { data: response || [] }
    } catch (error) {
      // Qui puoi aggiungere una gestione errori custom
      return { data: [] }
    }
  }
}
